module.exports = __webpack_public_path__ + "static/img/oldqocode.bbd9899a.png";